module.exports = "<div class=\"loading-container visible active\">\r\n    <div class=\"loading\">\r\n        <ion-spinner icon=\"crescent\"></ion-spinner>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/views/components/loading.html
// module id = KOt4
// module chunks = 1